import Immutable from 'seamless-immutable';

import {
    SUBMISSION_REVIEWER_LIST_REQUEST,
    SUBMISSION_REVIEWER_LIST_SUCCESS,
    SUBMISSION_REVIEWER_LIST_ERROR,
    SUBMISSION_REVIEWER_LIST_UPDATE_FILTER
} from 'Actions/submissionReviewer';
import { SUBMISSION_INVITE_EXTERNAL_SUCCESS } from 'Actions/submission';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    filter: {
        reload: false,
    },
    defaultFilter: {include: ['invite', 'attachment.file'], page: 1, order: 'invite.created_at desc'},
    data: {},
    metadata: {},
    order: '',
});

export default function packListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SUBMISSION_REVIEWER_LIST_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case SUBMISSION_REVIEWER_LIST_SUCCESS: {
            const { round, data, metadata } = action.payload;
            return state.merge({
                loading: false,
                success: true,
                error: false,
                data: state.data.merge({ [round]: data }),
                metadata: state.metadata.merge({ [round]: {...metadata} }),
            });
        }

        case SUBMISSION_REVIEWER_LIST_UPDATE_FILTER: {
            const filter = state.filter[action.payload.round] ?
                state.filter[action.payload.round] :
                state.defaultFilter.merge({where: {submission_review_round_id: action.payload.round}});

            return state.merge({
                filter: state.filter.merge({ [action.payload.round]: filter.merge(action.payload.filter) }),
            });
        }

        case SUBMISSION_INVITE_EXTERNAL_SUCCESS:
            return state.merge({
                filter: state.filter.merge({ reload: !state.filter.reload }),
            });

        case SUBMISSION_REVIEWER_LIST_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/submissionReviewersListReducer.js